import 'bootstrap/js/src/modal';
import image from '../../utils/image';
import multipack from '../../utils/multipack';
import AddToWishlist from '../product/wishlist';

export default class ProductSet {
  constructor() {
    this.$quantityInput = $('.input-quantity');
    // this.$addToCartContainer = $('.prices-add-to-cart-actions');
    this.$globalPricing = $('.bundle-footer .global-price');
    this.$globalSORPricing = $('.bundle-footer .sor-price-container-value');
    this.isSetVariationListenerBound = false;
  }

  init() {
    this.listeners();
    this.bindVariationListener();
    this.updateQualitySelectsState();
    this.syncAllSetItemSorPrices();
    this.updateGlobalTotals();
    this.updateAddToCartGlobalState();
    new AddToWishlist().init();
  }

  syncAllSetItemSorPrices() {
    $('.product-detail.set-item').each((index, element) => {
      this.syncSetItemSorPriceWithMultipack($(element));
    });
  }

  // Aligns data-sor-price of the set-item to the unit SOR price of the active multipack.
  // The template renders the base SOR price, without this sync,
  // updateGlobalTotals would use an incorrect value for the total SOR calculation.
  syncSetItemSorPriceWithMultipack($setItemContainer, fallback) {
    if (!$setItemContainer || !$setItemContainer.length) return;

    const $active = $setItemContainer.find('.multi-pack-items.is-active').first();
    if ($active.length) {
      const rawSubscription = $active.attr('data-unit-subscription');
      const rawFormattedSubscription = $active.attr('data-unitprice-subscription');
      const normalizedSubscription = (rawSubscription || rawFormattedSubscription || '')
        .toString()
        .replace(',', '.')
        .replace(/[^0-9.-]/g, '');
      const raw = parseFloat(normalizedSubscription);
      if (!isNaN(raw) && raw > 0) {
        $setItemContainer.attr('data-sor-price', raw);
        return;
      }
    }

    if (fallback !== undefined && fallback !== null) {
      $setItemContainer.attr('data-sor-price', fallback);
    }
  }

  listeners() {
    $('body').on('after:quantitychange', '.product-detail.set-item .input-quantity', (e) => {
      const $setItemContainer = $(e.currentTarget).closest('.product-detail.set-item');
      this.syncSetItemSorPriceWithMultipack($setItemContainer);
      this.updateSetItemUnitPricePerKg($setItemContainer);
      this.updateGlobalTotals();
      this.updateAddToCartGlobalState();
    });
  }

  bindVariationListener() {
    if (this.isSetVariationListenerBound) {
      return;
    }

    this.isSetVariationListenerBound = true;
    $('body').on('product:afterAttributeSelect', (e, response) => {
      const $eventContainer = response && response.container ? response.container : null;
      const $setItemContainer = $eventContainer ? $eventContainer.closest('.product-detail.set-item') : $();
      const productData = response && response.data ? response.data.product : null;

      if (!$setItemContainer.length || !response || response.error || !productData) {
        return;
      }

      if (productData.images) {
        image.carousel(productData.images, productData.providerVideoUrl, $setItemContainer);
        this.updateSetItemGallery($setItemContainer);
      }

      this.updateSetItemDetails($setItemContainer, productData);
      this.updateSetItemMultipack($setItemContainer, productData);
      this.syncSetItemSorPriceWithMultipack($setItemContainer, this.getSetItemSorPrice(productData));
      this.updateSetItemUnitPricePerKg($setItemContainer, productData);
      this.updateGlobalTotals();
      this.updateAddToCartGlobalState();
    });
  }

  updateSetItemMultipack($setItemContainer, productData) {
    const multipackHtml = productData && productData.multiPackHtml ? productData.multiPackHtml : '';
    const $existingMultipack = $setItemContainer.find('.multi-pack.attributes, .multipack-container').first();

    if (!multipackHtml) {
      if ($existingMultipack.length) {
        $existingMultipack.remove();
      }
      return;
    }

    if ($existingMultipack.length) {
      $existingMultipack.replaceWith(multipackHtml);
    } else {
      const $attributes = $setItemContainer.find('.attributes').first();
      if ($attributes.length) {
        $attributes.before(multipackHtml);
      }
    }

    this.mountSetItemMultipackSlider($setItemContainer);
    this.syncMultipackSelectionWithQuantity($setItemContainer);
  }

  syncMultipackSelectionWithQuantity($setItemContainer) {
    const $items = $setItemContainer.find('.multi-pack-items');
    if (!$items.length) {
      return;
    }

    const currentQty = String(
      $setItemContainer.find('.input-quantity').first().val() || $setItemContainer.find('.quantity-select').first().val() || ''
    );
    const currentQtyNum = parseInt(currentQty, 10);
    let bestQty = -1;
    let $matchingItem = $();

    $items.each((idx, el) => {
      const optionQty = parseInt($(el).attr('data-quantity'), 10);
      if (!isNaN(optionQty) && !isNaN(currentQtyNum) && optionQty <= currentQtyNum && optionQty > bestQty) {
        bestQty = optionQty;
        $matchingItem = $(el);
      }
    });

    if ($matchingItem.length) {
      $items.removeClass('is-active');
      $matchingItem.addClass('is-active');
      this.applySetItemUnitPriceFromMultipack($setItemContainer, $matchingItem);
      return;
    }

    $items.removeClass('is-active');
  }

  applySetItemUnitPriceFromMultipack($setItemContainer, $matchingItem) {
    let $unitPriceContainer = $setItemContainer.find('.has-multipack-price').first();
    if (!$unitPriceContainer.length) {
      const $fallbackPrices = $setItemContainer.find('.details-container .prices').first();
      if ($fallbackPrices.length) {
        $fallbackPrices.addClass('has-multipack-price');
        $unitPriceContainer = $fallbackPrices;
      }
    }

    const $unitPriceValue = $unitPriceContainer.find('.sales .value').first().length
      ? $unitPriceContainer.find('.sales .value').first()
      : $unitPriceContainer.find('.value').first();
    const unitPrice = $matchingItem.attr('data-unitprice');
    const unitContent = $matchingItem.attr('data-unit-content');

    if ($unitPriceContainer.length && $unitPriceValue.length && unitPrice) {
      $unitPriceValue.text(unitPrice);
      if (unitContent !== undefined) {
        $unitPriceValue.attr('content', unitContent);
      }
      $unitPriceContainer.removeClass('d-none');
      this.updateSetItemUnitPricePerKg($setItemContainer);
    }
  }

  updateSetItemUnitPricePerKg($setItemContainer, productData) {
    if (!$setItemContainer || !$setItemContainer.length) return;

    const $qfis = $setItemContainer.find('.product-qfis').first();
    if (!$qfis.length) return;

    const hideUnitPrice = productData && productData.idt_nascondi_prezzo_unitario === true;
    if (hideUnitPrice) {
      $qfis.hide();
      return;
    }

    const idtQfisRaw = productData && productData['idt-qfis'] ? productData['idt-qfis'] : $qfis.attr('data-idt-qfis');
    const idtCumd = productData && productData['idt-cumd'] ? productData['idt-cumd'] : $qfis.attr('data-idt-cumd');
    const idtQfis = parseFloat(idtQfisRaw);

    if (!idtQfis || !idtCumd) return;

    const $activeMultiPack = $setItemContainer.find('.multi-pack-items.is-active').first();
    const activeUnitContent = $activeMultiPack.length ? parseFloat($activeMultiPack.attr('data-unit-content')) : NaN;
    const rowPriceContent = parseFloat($setItemContainer.find('.sales .value').first().attr('content'));
    const basePrice = !isNaN(activeUnitContent) ? activeUnitContent : rowPriceContent;

    if (isNaN(basePrice)) return;

    const formatted = (basePrice / idtQfis)
      .toLocaleString('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      .replace(/\s+/g, '');
    $qfis.attr('data-idt-qfis', String(idtQfisRaw));
    $qfis.attr('data-idt-cumd', String(idtCumd));
    $qfis.html(`<div>(${formatted}/${idtCumd})</div>`).show();
  }

  mountSetItemMultipackSlider($setItemContainer) {
    multipack.mountSliders($setItemContainer.find('.multi-pack-slider'));
  }

  updateGlobalTotals() {
    let priceGlobal = 0;
    let sorPriceGlobal = 0;

    $('.product-detail.set-item:not(.not-available)').each(function () {
      const $row = $(this);
      const qty = Number($row.find('.input-quantity').first().val()) || Number($row.find('.quantity-select option:selected').val()) || 1;
      const currentPrice =
        parseFloat($row.find('.sales .value').first().attr('content') || $row.find('.value').first().attr('content')) || 0;
      const sorPriceItem = parseFloat($row.attr('data-sor-price')) || 0;

      priceGlobal += currentPrice * qty;
      sorPriceGlobal += sorPriceItem * qty;
    });

    const moneyFormat = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
    this.$globalPricing.html(moneyFormat.format(priceGlobal));
    this.$globalSORPricing.html(moneyFormat.format(sorPriceGlobal));
    this.updateSorSavingValue(priceGlobal, sorPriceGlobal);
  }

  updateSorSavingValue(priceGlobal, sorPriceGlobal) {
    const $savingWrap = $('#pdp-refill-options .smart-order-refill__saving-wrap');
    const $savingValue = $('#pdp-refill-options .smart-order-refill__saving-value');

    if (!$savingWrap.length || !$savingValue.length) {
      return;
    }

    const savingAmount = (parseFloat(priceGlobal) || 0) - (parseFloat(sorPriceGlobal) || 0);
    const sorPriceText = $('#pdp-refill-options .sor-price-container-value').first().text() || '';
    const currencySymbol = sorPriceText.replace(/[\d.,\s\u00A0]/g, '') || '€';

    if (savingAmount <= 0) {
      $savingWrap.addClass('no-saving d-none');
      $savingValue.html(`0,00${currencySymbol}`);
      return;
    }

    $savingWrap.removeClass('no-saving d-none');
    $savingValue.html(`${savingAmount.toFixed(2).replace('.', ',')}${currencySymbol}`);
  }

  updateSetItemGallery($setItemContainer) {
    const $setPrimarySlider = $setItemContainer.find('.primary-slider').first();
    const $setSecondarySlider = $setItemContainer.find('.secondary-slider').first();

    if ($setPrimarySlider.length > 0 && $setSecondarySlider.length > 0) {
      const primarySliderEl = $setPrimarySlider.get(0);
      const secondarySliderEl = $setSecondarySlider.get(0);

      if (primarySliderEl && primarySliderEl.splide) {
        primarySliderEl.splide.destroy(true);
      }

      if (secondarySliderEl && secondarySliderEl.splide) {
        secondarySliderEl.splide.destroy(true);
      }

      image.carouselImage(primarySliderEl, secondarySliderEl);
      image.zoom(primarySliderEl);
    }
  }

  updateSetItemDetails($setItemContainer, productData) {
    const sorPriceValue = this.getSetItemSorPrice(productData);
    $setItemContainer.attr('data-sor-price', sorPriceValue);

    const isAvailable = productData.available && productData.readyToOrder;
    $setItemContainer.toggleClass('not-available', !isAvailable);
    this.updateSetItemQuantitySelectState($setItemContainer, isAvailable);

    if (productData.id) {
      $setItemContainer.attr('data-pid', productData.id);
      $setItemContainer.find('.product-id').text(productData.id);
    }

    const $nameLinks = $setItemContainer.find('.product-name a');
    if ($nameLinks.length && productData.productName) {
      $nameLinks.text(productData.productName);
      if (productData.selectedProductUrl) {
        $nameLinks.attr('href', productData.selectedProductUrl);
      }
    }

    if (productData.promotionsHtml !== undefined) {
      $setItemContainer.find('.promotions').empty().html(productData.promotionsHtml);
    }

    if (productData.price && productData.price.html) {
      const $priceSelector = $setItemContainer.find('.prices .price');
      if ($priceSelector.length > 0) {
        $priceSelector.replaceWith(productData.price.html);
      }
    }

    const $availability = $setItemContainer.find('.product-availability');
    if ($availability.length > 0) {
      $availability.attr('data-ready-to-order', productData.readyToOrder).attr('data-available', productData.available);
      const availabilityMessage =
        productData.availability && productData.availability.messages && productData.availability.messages.length
          ? productData.availability.messages[0].msg
          : '';
      $setItemContainer.find('.availability-msg').empty().html(`<li><div>${availabilityMessage}</div></li>`);
    }
  }

  updateAddToCartGlobalState() {
    const hasAtLeastOneAvailable = $('.product-detail.set-item:not(.not-available)').length > 0;
    $('.add-to-cart-global').prop('disabled', !hasAtLeastOneAvailable);
  }

  updateQualitySelectsState() {
    $('.product-detail.set-item').each((index, element) => {
      const $setItem = $(element);
      const isAvailable = !$setItem.hasClass('not-available');
      this.updateSetItemQuantitySelectState($setItem, isAvailable);
    });
  }

  updateSetItemQuantitySelectState($setItemContainer, isAvailable) {
    const $quantityContainer = $setItemContainer.find('.quantity-change.counters').first();
    if (!$quantityContainer.length) return;

    // keep decrease button enabled to allow users to reduce quantity
    $quantityContainer.find('button:not(.decrease), select').prop('disabled', !isAvailable);
    $quantityContainer.find('.decrease, input').prop('disabled', false);
  }

  getSetItemSorPrice(productData) {
    const sorPrice = productData && productData.price ? productData.price.sorPrice : null;

    if (typeof sorPrice === 'number') {
      return sorPrice;
    }

    if (sorPrice && typeof sorPrice.value === 'number') {
      return sorPrice.value;
    }

    if (sorPrice && sorPrice.decimalPrice !== undefined && sorPrice.decimalPrice !== null) {
      return parseFloat(sorPrice.decimalPrice) || 0;
    }

    return 0;
  }
}
